import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { fileUrl } from "@/lib/api";

export const MediaLightbox = ({ items, index, onChange }) => {
  const item = index !== null ? items[index] : null;
  const go = (d) => onChange((index + d + items.length) % items.length);
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onChange(null)}>
      <DialogContent data-testid="gallery-lightbox" className="max-w-6xl w-[96vw] border-0 bg-[#0e1510] p-0 text-stone-100">
        <DialogTitle className="sr-only">{item?.title || "Imagen"}</DialogTitle>
        {item && (
          <div className="relative">
            {item.type === "video" ? (
              <video key={item.id} src={fileUrl(item.url)} controls autoPlay playsInline className="max-h-[80vh] w-full bg-black" data-testid="lightbox-video" />
            ) : (
              <img src={fileUrl(item.url)} alt={item.title} className="max-h-[80vh] w-full object-contain" data-testid="lightbox-image" />
            )}
            {items.length > 1 && (
              <>
                <button onClick={() => go(-1)} data-testid="lightbox-prev" aria-label="Anterior" className="absolute left-3 top-1/2 -translate-y-1/2 rounded-full bg-black/50 p-2 hover:bg-[#8B2B22] transition-colors"><ChevronLeft /></button>
                <button onClick={() => go(1)} data-testid="lightbox-next" aria-label="Siguiente" className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full bg-black/50 p-2 hover:bg-[#8B2B22] transition-colors"><ChevronRight /></button>
              </>
            )}
            <p className="f-display px-6 py-4 text-lg" data-testid="lightbox-caption">{item.title}</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
